import { inject } from "mobx-react";
import { Fragment, useMemo } from "react";
import { Heading } from "../../../../core/ui";
import { getFeedSubtitle } from "../../lib/coastFeed";
import { CoastFeedNavigation } from "./coast-feed-navigation/CoastFeedNavigation.component";
import { CoastFeedAds } from "./CoastFeedAds.component";
import type { CoastFeedArticlesProps } from "./CoastFeedArticles.component";
import { CoastFeedInTheNewsItem } from "./CoastFeedInTheNewsItem.component";
import { CoastFeedNoResults } from "./CoastFeedNoResults.component";
import "./CoastFeed.style.scss";

export const CoastFeedInTheNews = inject("store")(({ store, content, block, title }: CoastFeedArticlesProps) => {
  if (!store) {
    return null;
  }

  const subtitle = useMemo(() => getFeedSubtitle(store.routeParams, false), [store.routeParams]);
  // only display the header block if there are no feed filters selected
  const displayFirstItemBlock = !Object.keys(store.routeParams).length;

  const feedCardsContent = displayFirstItemBlock ? content?.slice(1) : content;

  return (
    <Fragment>
      <Heading level={2}>{title}</Heading>

      {content?.length && displayFirstItemBlock ? (
        <section className="coast-feed-header">
          <CoastFeedInTheNewsItem item={content[0]} />
        </section>
      ) : null}

      <CoastFeedNavigation />
      <Heading level={3}>{subtitle}</Heading>

      {feedCardsContent?.length ? (
        <div className="feed-cards">
          {feedCardsContent.map((item, itemIdx) => (
            <Fragment key={item.id}>
              <CoastFeedInTheNewsItem item={item} />
              <CoastFeedAds
                blockSize={block.value.size}
                itemCount={feedCardsContent?.length || 0}
                includeItemAd={false}
                blockId={block.id}
                itemIdx={itemIdx}
              />
            </Fragment>
          ))}
        </div>
      ) : (
        <CoastFeedNoResults />
      )}
    </Fragment>
  );
});

export default CoastFeedInTheNews;
